import { LoadingState } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function LoadingOrganizationsList() {
  const { t } = useTranslation();

  return (
    <LoadingState
      title={t("organizations.list.general.loading_organizations")}
      description={t("organizations.list.general.please_wait_while_we_load_the_organizations_for_you")}
    />
  );
}
